import { LANGUAGE_FILE_NAME_SUFFIX, SUPPORTED_LANGUAGE } from '../app/constants';
import { ObjectUtils } from '../app/core/utils/object.utils';

const BACKOFFICE_PROJECT_RELATIVE_URI_TEMPLATE = '/sfx/Mpf/Comment/Index/{projectId}';
const NOTIFICATIONS_HUB_RELATIVE_URI = '/hubs/live';

export function getBackofficeProjectUrlTemplate(backofficeBaseUrl: string): string {
    return `${backofficeBaseUrl}${BACKOFFICE_PROJECT_RELATIVE_URI_TEMPLATE}`;
}

export function getNotificationsHubUrl(wsProtocol: string, serverUrl: string): string {
    return `${wsProtocol}${serverUrl}${NOTIFICATIONS_HUB_RELATIVE_URI}`;
}

export function isValidServerUrl(url: string, originsPerUserType: Record<string, string>): boolean {
    return Object.values(originsPerUserType).includes(url);
}

export function parseLanguages(localesJson: { locales: string[]; prefix: string }): string[] {
    return localesJson.locales.map(
        (lang: string): SUPPORTED_LANGUAGE =>
            SUPPORTED_LANGUAGE[
                ObjectUtils.getKeyForValue<keyof typeof SUPPORTED_LANGUAGE>(LANGUAGE_FILE_NAME_SUFFIX, lang)
            ]
    );
}
